import PropTypes from "prop-types"
import { Card, CardHeader, CardContent, IconButton } from "@mui/material"
import { Close } from "@mui/icons-material"
import ModelSelector from "modules/model-selector"
import { getAssetClassFromMic } from "helpers/securities"

function NoSecurity({ onClose, security, setModel, selectedModel }) {
  const header = <>
    <div>Security Not Found</div>
    <div className="controls">
      <IconButton onClick={onClose} color="default" size="large">
        <Close />
      </IconButton>
    </div>
  </>

  const assetClass = getAssetClassFromMic(security.mic)
  const subHeader = <div className="subheader nosecurity">
    {setModel
      && <ModelSelector
        disablePortal
        noSpinner
        disableUnderline
        modelId={selectedModel.id}
        modelName={selectedModel.name}
        setModel={setModel}
        resourceType={assetClass === "swap" ? "swap" : "security"}
        resourceId={security}
      />}
  </div>

  return <Card className="modules_security-profile">
    <CardHeader className="card-header" disableTypography title={header} />
    <CardHeader className="card-subheader" disableTypography title={subHeader} />
    <CardContent className="card-content">
      <h4>The profile for this security is currently unavailable.</h4>
    </CardContent>
  </Card>
}

NoSecurity.propTypes = {
  onClose: PropTypes.func.isRequired,
  setModel: PropTypes.func.isRequired,
  security: PropTypes.object.isRequired,
  selectedModel: PropTypes.object.isRequired,
}

export default NoSecurity
